import { handlePushToDataLayerForLocationSearch } from 'features/location/Location.tracking';
import { useOnUpdateOnly } from 'hooks/UseOnUpdateOnly';
import type { UseLocationSearchTrackingArgs } from 'components/SearchPage/hooks/useLocationSearchTracking/useLocationSearchTracking.typed';

function useLocationSearchTracking(props: UseLocationSearchTrackingArgs) {
  const {
    isLocationBottomSheetOpen,
    isLocationDropdownExpanded,
    county,
    countyTown,
    radius,
  } = props;

  useOnUpdateOnly(() => {
    if (!isLocationBottomSheetOpen && county) {
      handlePushToDataLayerForLocationSearch({
        county,
        countyTown,
        radius,
      });
    }
  }, [isLocationBottomSheetOpen]);

  useOnUpdateOnly(() => {
    if (!isLocationDropdownExpanded && county) {
      handlePushToDataLayerForLocationSearch({
        county,
        countyTown,
        radius,
      });
    }
  }, [isLocationDropdownExpanded]);
}

export { useLocationSearchTracking };
